import { BackendItem, BackendSubItem } from '../../items/types/backend-item.types';
import { calculateWeights, parseMaterialGradeId } from '../../../shared/utils/calculations.utils';
import { formatDate, normalizePercentage } from '../../../shared/utils/formatters.utils';

import { TableRowData } from '../types/excel.types';

export const getItemFields = (item: BackendItem): Partial<TableRowData> => {
   const { dwpDeviation, cpNetWeight, itemPartsWeight, itemPartsEmission } = calculateWeights(item);

   return {
      itemNumber: item.itemNo,
      itemName: item.itemName,
      hfb: item.hfb,
      buCodePru: item.buCodePru,
      buCodePdu: item.buCodePdu,
      pa: item.pa,
      familyName: item.familyName,
      itemState: item.itemState,
      cpNetWeight,
      partsWeight: itemPartsWeight,
      partsEmission: itemPartsEmission,
      dwpDeviation,
      saleStartDateGlobal: formatDate(item.saleStartDateGlobal, 'iso'),
      saleEndDateGlobal: formatDate(item.saleEndDateGlobal, 'iso'),
      isBase: item.isBase,
      parentItemNo: item.parentItemNo,
   };
};

export const getSubItemFields = (subItem: BackendSubItem): Partial<TableRowData> => ({
   id: subItem.id,
   partDetail: subItem.materialType,
   part: subItem.materialPart,
   category: subItem.category,
   materialGrade: subItem.materialPartText,
   matType: subItem.matType,
   subTypeId: subItem.subTypeId,
   materialGradeId: parseMaterialGradeId(subItem.materialGradeId),
   compositionShare: normalizePercentage(subItem.compositionShare as number | undefined),
   threeDModelNo: subItem.threeDModelNo,
   totalWeight: subItem.totalWeight,
   totalEmission: subItem.totalEmission,
   quantity: subItem.quantity != null ? String(subItem.quantity) : undefined,
   mass: subItem.mass,
   volume: subItem.volume,
   density: subItem.density,
   dwpTotalWeight: subItem.totalWeight,
   recycledContent: normalizePercentage(subItem.recycledContent),
   renewableContent: normalizePercentage(subItem.renewableContent),
   updatedBy: subItem.updatedBy,
   updatedAt: formatDate(subItem.updatedAt, 'iso'),
   comment: subItem.comment,
   active: subItem.active !== false,
});
